import store from '../../store'
import find from 'lodash/find'

export function getRecordingForMeeting(meetingId) {	
	const state = store.getState()
	const recording= find(state.recordings, {'meeting':`${meetingId}`})
	return recording
}

